<template>
<div class="furnish-main">
  <el-button  type="primary" @click="sureEntry()" v-if="ProcessState == 3" style="margin-bottom: 10px;">入场确认</el-button>
  <el-button   v-if="ProcessState >= 4" style="margin-bottom: 10px;">已入场</el-button>
  <el-descriptions title="" :column="1" border label-style="width: 120px;">
    <el-descriptions-item label="防火责任书">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="防火责任书" >
        <el-link type="primary" class="el-link-common" @click="getFile('单元防火责任书.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="重点提示">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="重点提示" >
        <el-link type="primary" class="el-link-common" @click="getFile('装修重点提示.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="备案表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="备案表" >
        <el-link type="primary" class="el-link-common" @click="getFile('装修备案表.docx')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
    <el-descriptions-item label="巡检表">
      <FitmentFileSubgroup :fitment_id="mainObj.id" mode_type="巡检表">
        <el-link type="primary" class="el-link-common" @click="getFile('P41-01-05装修巡查表.xls')">下载模板</el-link>
      </FitmentFileSubgroup>
    </el-descriptions-item>
  </el-descriptions>
</div>
</template>

<script>
import FitmentFileSubgroup from "./components/FitmentFileSubgroup";
import AppConfig from "../../../../../../config/AppConfig";
export default {
  name: "DecorationEntry",
  components: {FitmentFileSubgroup},
  inject:['mainObj','componentId','setComponentId','ProcessState','setProcessState'],
  data(){
    return{
      ProcessState:0,
    }
  },
  mounted() {
    this.getData();
  },
  methods:{
    getData(){
      const that = this;
      ERP.postRequest({url:"admin/HouseFurnish/getProcessState",data:{house_id:that.mainObj.house_id,id:that.mainObj.id}},ret=>{
        if(ret.code){
          that.ProcessState=ret.data;
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
      })
    },
      sureEntry() {
        const that = this;
        if(that.mainObj.id != '') {
          this.$confirm('是否确认入场, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            ERP.postRequest({url:"admin/HouseFurnish/setProcessState",data:{id:that.mainObj.id,ProcessState:4}},ret=>{
              if(ret.code){
                that.ProcessState = 4
                this.$msgbox.alert(ret.msg||"操作成功")
              }else{
                this.$msgbox.alert(ret.msg||"查询失败")
              }
            })

          }).catch(() => {
            // this.$message({type: 'info',message: '已取消'});
          });
        }

      },
      getFile(file_name) {
        // let url=AppConfig.erp_server+"/excel/house/"+file_name;
        let url=AppConfig.erp_server+"/admin/HouseFurnish/download?file_name="+file_name;
        window.open(url, "_blank");
      }
  }
}
</script>

<style lang="scss" scoped>
@import url(../../common.scss);
.furnish-main{
  height: calc(100vh - 230px);
  overflow-y: scroll;
  .el-link-common{
    margin-right: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/User/CustomerManagement/components/furnish/DecorationEntry.vue